module.exports = __webpack_public_path__ + "img/card-profile2.b198693d.jpg";